import axios from 'axios';
import Vue from 'vue';
import {getNswSchoolSafetyApiUrl} from '../../utils/config';

const fetchPermissions = () => {
  const url = getNswSchoolSafetyApiUrl() + "/permissions";
  return axios.get(url,
    {
      headers: Vue.prototype.$OAuth.buildHttpHeader({
        "adfs":"true"
      })
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      // eslint-disable-next-line
      console.error(err);
      throw err;
    });
};

export default { fetchPermissions };
